export const FORM_CODE_FF008 = 'FF008';

export type CareerUpConfirmationStep =
  | 'hasCard'
  | 'careerUpCardUploaded'
  | 'driversLicenseUploaded'
  | 'cardPassword';

export type YesNo = 'yes' | 'no' | '';

export interface CareerUpConfirmationFormValues {
  hasCareerUpCard?: YesNo;
  careerUpCardUploaded?: YesNo;
  driversLicenseUploaded?: YesNo;
  cardPassword?: string;
}

export interface CopyUploadMeta {
  hasUpload: boolean;
  fileName?: string;
  uploadedAt?: string;
}

export interface CareerUpConfirmationUploadMeta {
  vc008: CopyUploadMeta;
  vc010: CopyUploadMeta;
}
